<template lang="pug">
v-btn.grey--text.text--darken-4(v-if="disponivel", depressed, color="#25D366", @click="abrirWhatsApp") Avisar no WhatsApp
</template>

<script>
import { tipoAvisoCliente, linkWhatsAppStatusPedido, podeAvisarClienteWhatsApp } from '@/util/whatsappCliente';

export default {
  props: {
    pedido: {
      type: Object,
      default: null
    },
  },
  computed: {
    disponivel () {
      return podeAvisarClienteWhatsApp(this.pedido);
    },
  },
  methods: {
    abrirWhatsApp () {
      this.$firebase.logEvent('pedido_whatsapp_cliente_clicked', {
        pedido_id: this.pedido.id,
        establishment_id: this.pedido.estabelecimento_id,
        tipo: tipoAvisoCliente(this.pedido),
      });
      window.open(linkWhatsAppStatusPedido(this.pedido), '_blank');
    },
  },
}
</script>
